/**
 * Build endpoint for dms REST endpoints.
 * The /customer/:customer-id part is already included.
 *
 * @return {String} dids base URL
 */
export const didsBaseUrl = "dids";

export const claimableDidsUrl = `${didsBaseUrl}/claimable`;
export const dmsCountriesUrl = `${didsBaseUrl}/countries`;
